import { AiTool, AiToolType } from '@feedyou-ai/feedbot-schema'

import { generateId } from '../../../lib/generateId'

export function isDialogTypeTool(tool: AiTool) {
  return tool.action?.type === 'dialog'
}

export function getNoteTooltipText(instructions: string | undefined): string {
  if (instructions) {
    return `Click here to modify AI step instructions`
  }

  return `You can click here to specify detailed AI step instructions instead of using just a goal`
}

export function createInitialToolForGivenType(type: AiToolType) {
  return { id: generateId.stepId(), action: createDefaultToolActionForType(type) }
}

function createDefaultToolActionForType(type: AiToolType) {
  switch (type) {
    case 'code':
      return { type, code: undefined }
    case 'store':
      return { type, store: undefined }
    case 'dialog':
      return { type, dialog: undefined }
    default:
      return {}
  }
}
